module.exports = __webpack_public_path__ + "system/img/ok.7d511279.png";